import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from 'app/model/pipeline/copysource/tabular-type.copysource';
import { AzureTableDataset } from 'app/model/dataset/azure-table.dataset';
import { IAttribute } from 'app/model/base/annotation';


@Metamodel.model({
    name: 'AzureTableSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(AzureTableDataset) }
})
export class AzureTableCopySource extends TabularCopySource {
    public static readonly IGNORE_TABLE_NOT_FOUND: IAttribute;
    @Metamodel.attribute({
        templatable: true,
        association: 'IGNORE_TABLE_NOT_FOUND',
        display: stringResources.ModelName_IgnoreTableNotFound
    })
    public ignoreTableNotFound: boolean = false;
}
